import styled from '@emotion/styled'
import { Box, IconButton } from '@mui/material'
import React, { useCallback, useEffect } from 'react'
import { AiOutlineReload } from 'react-icons/ai'
import { AsideSize } from '../../config'
import { useTranslation } from '../../hooks/Localization'
import { useAppDispatch, useAppSelector } from '../../states/app/hooks'
import { selectCaptcha, setCaptchaCode } from '../../states/features/Captcha/CaptchaSlice'
const StyledBoxCaptcha = styled(Box)`
    position: relative;
    display: none;
    & img {
        position: absolute;
        right: 0px;
        top: -17px;
        background: cornsilk;
        float: right;
        margin-top: 10px;
        border-radius: 5px;
    }
`
const StyledReloadIcon = styled(IconButton)`
    position: absolute;
    right: 150px;
    top: 7px;
` as typeof IconButton

const Captcha: React.FC = ({ children }) => {
    const t = useTranslation
    const dispatch = useAppDispatch()
    const captcha = useAppSelector(selectCaptcha)

    const handleReloadCaptcha = useCallback(() => {
        dispatch(setCaptchaCode())
    }, [dispatch])

    useEffect(() => {
        dispatch(setCaptchaCode())
    }, [dispatch])

    return (
        <StyledBoxCaptcha>
            {children}
            <Box component="img" src={process.env.REACT_APP_PUBLIC_API + '/captcha/get-captcha?code=' + captcha} alt={t('Captcha')} />
            <StyledReloadIcon onClick={handleReloadCaptcha} color="secondary" aria-label={t('Reload')} component="span">
                <AiOutlineReload size={AsideSize.ICON} />
            </StyledReloadIcon>
        </StyledBoxCaptcha>
    )
}

export default Captcha
